import { Controller } from '@hotwired/stimulus';

// Persists a form's current state to the session on every change (a partial PATCH, not a full submit)
// and applies the returned Turbo Stream — used on the upsells page so picking a tier or add-on product
// immediately updates the order sidebar. The form's normal submit still advances the flow.
export default class extends Controller {
  static values = { url: String };

  connect() {
    // The controls the customer has changed. A section validates as a whole on every save, so the
    // server needs to know which controls they have been to — the rest are still to come, and their
    // errors stay hidden until then.
    this.touched = new Set();
  }

  save(event) {
    const changed = event?.target?.name;
    if (changed) this.touched.add(changed);

    const headers = { Accept: 'text/vnd.turbo-stream.html' };
    // CSRF meta is absent when forgery protection is off (e.g. the test env); guard so save()
    // doesn't throw on a null meta tag and silently skip the request.
    const csrf = document.querySelector('meta[name="csrf-token"]');
    if (csrf) headers['X-CSRF-Token'] = csrf.content;

    fetch(this.urlValue, {
      method: 'PATCH',
      headers,
      body: this.body(),
      // A change is often the customer leaving the field to click something else — submitting another
      // form, or starting the payment. Without keepalive the browser drops this request when that
      // navigation begins, and the change is lost.
      keepalive: true
    })
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html));
  }

  body() {
    const body = new FormData(this.element);
    this.touched.forEach((name) => body.append('touched[]', name));
    return body;
  }
}
